import React, { FC }                    from 'react';
import { RouteComponentProps }          from 'react-router-dom';
import { useSelector }                  from 'react-redux';
import styled                           from 'styled-components';
import { EUserRole, EAppPage }          from '@enums/common';
import { EIntraUsersPage }              from '@enums/manageIntranetUsers';
import { getAuthUser }                  from '@modules/auth/authReducer';
import { IntranetUsersListContainer }   from '@modules/manageIntranetUsers/containers/IntranetUsersListContainer';
import { IntranetUserDetailsContainer } from '@modules/manageIntranetUsers/containers/IntranetUserDetailsContainer';

const Wrapper = styled.div`
  max-width  : 1680px;
  margin     : 30px auto;
  padding    : 0 30px;
  transition : .6s ease;

  @media (min-width: 960px) {
    padding: 0 100px;
  }

  @media (min-width: 1280px) {
    padding: 0 200px;
  }
`;

interface IParams {
  page : EIntraUsersPage;
  id?  : string;
}

export const ManageIntranetUsersContainer: FC<RouteComponentProps<IParams>> = ({
  history : { push },
  match   : {
    params: { id, page = EIntraUsersPage.list },
  },
}) => {
  const authUser = useSelector(getAuthUser);

  return (
    <Wrapper>
      {page === EIntraUsersPage.list && (
        <IntranetUsersListContainer
          isSuperAdmin = {authUser.role === EUserRole.SuperAdmin}
          onAddNewUser = {() => push(`${EAppPage.ManageIntranetUsers}/${EIntraUsersPage.add}`)}
        />
      )}

      {(page === EIntraUsersPage.add || (page === EIntraUsersPage.edit && !!id)) && (
        <IntranetUserDetailsContainer
          id       = {id}
          authUser = {authUser}
          onCancel = {() => push(`${EAppPage.ManageIntranetUsers}/${EIntraUsersPage.list}`)}
        />
      )}
    </Wrapper>
  );
};
